<template>
  <div class="contact-us full-screen mt-4">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <div class="container">
      <h3 class="text-warning text-center"><b>Para ingresar a la plataforma y conocer más acerca de nuestros servicios</b></h3>
      <h1 class="card-title text-warning text-center">Crea una cuenta</h1>
      <a id="registro-anchor"></a>

      <div class="row">
        <div class="col-12">
          <b-card id="card">
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(register)">
                <SignUp :user="user" @submit.prevent />
                <button type="submit" :class="loading ? 'disabled' : ''" class="btn orange-btn float-right">Continuar</button>
              </form>
            </ValidationObserver>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignUp from "@/pages/signin/Form.vue";
import { ClientesApi } from "@/api";
import { showToast } from "@/utils/showToast";

export default {
  name: "SignIn",

  components: {
    SignUp,
  },

  data() {
    return {
      loading: false,
      user: {
        firstName: null,
        lastNameP: null,
        lastNameM: null,
        email: null,
        password: null,
      },
    };
  },

  methods: {
    register() {
      this.loading = true;

      ClientesApi.create({
        nombre: this.user.firstName,
        paterno: this.user.lastNameP,
        materno: this.user.lastNameM,
        email: this.user.email,
        contraseña: this.user.password,
        roles_id: 3,
      })
        .then((response) => {
          showToast(
            this,
            "Registro completo, por favor revise su correo electrónico y verifique su cuenta para poder iniciar sesión",
            { timeout: 5000 },
            "success",
          );
          this.loading = false;

          return this.$router.push({ name: "Login" });
        })
        .catch((error) => {
          this.loading = false;
          console.log(error.status);
          if (error.status == "409") {
            showToast(
              this,
              "Este correo ya está registrado. Si no recuerda su contraseña, dé clic en Olvidé mi contraseña en el apartado Iniciar sesión",
              { timeout: 8000 },
              "error",
            );
          } else {
            showToast(this, "Sucedió un error, intente más tarde", {}, "error");
          }
        });
    },
  },
};
</script>

<style scoped>
#card {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #ea640b;
  font-size: 13px;
}
</style>
